// Lets the Supabase client's session persistence follow the user's
// "Remember Me" choice on the Sign In page: checked -> localStorage
// (survives browser restarts), unchecked -> sessionStorage (cleared when
// the tab/browser closes). Defaults to localStorage so every other sign-in
// path (Google OAuth, signup, invite acceptance) keeps today's behavior.
const REMEMBER_ME_KEY = "lg_remember_me";

function activeStorage(): Storage {
  return localStorage.getItem(REMEMBER_ME_KEY) === "false" ? sessionStorage : localStorage;
}

export function setRememberMe(remember: boolean) {
  localStorage.setItem(REMEMBER_ME_KEY, String(remember));
  // Unchecking after a previous "remembered" session shouldn't leave a
  // stale copy of the token sitting in localStorage once we start writing
  // to sessionStorage instead.
  if (!remember) {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith("sb-")) localStorage.removeItem(key);
    }
  }
}

export const authStorage = {
  getItem: (key: string) => activeStorage().getItem(key),
  setItem: (key: string, value: string) => activeStorage().setItem(key, value),
  removeItem: (key: string) => activeStorage().removeItem(key),
};
